import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { Button } from '~/components/atoms/index.ts';

interface ConfirmationModalProps {
  open: boolean;
  title: string;
  description: string;
  cancelText: string;
  confirmText: string;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  open,
  title,
  description,
  cancelText,
  confirmText,
  onConfirm,
  onClose,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    aria-labelledby="confirmation-modal-title"
    aria-describedby="confirmation-modal-description"
  >
    <DialogTitle
      id="confirmation-modal-title"
      sx={{
        justifyContent: 'center',
      }}
    >
      {title}
    </DialogTitle>
    <DialogContent>
      <DialogContentText id="confirmation-modal-description">
        {description}
      </DialogContentText>
    </DialogContent>
    <DialogActions
      sx={{
        display: 'flex',
        justifyContent: 'center',
        gap: '8px',
      }}
    >
      <Button variant="outlined" onClick={onClose}>
        {cancelText}
      </Button>
      <Button variant="outlined" onClick={onConfirm}>
        {confirmText}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmationModal;
